export const HIDE_SEAWARE_MESSAGE_COOKIE_NAME = 'hideSeawareMessage';
export const MAX_OLD_SYSTEM_YEAR = 2027;
export const MAX_OLD_SYSTEM_MONTH = 4;

export const SEAWARE_TEST_COOKIE_NAME = 'hx_test_live';
export const SEAWARE_TEST_COOKIE_VALUE = '550e8400-e29b-41d4-a716-446655440000';
